import {AuthenticationGateway} from '../domain/authentication.gateway';

export class AcceptedLasTermUseCase {
    constructor(private gate: AuthenticationGateway) {}

    async execute(): Promise<boolean> {
        return this.gate.acceptedLasTerm();
    }
}
